import type { InputType } from 'config'

import { FormTable, FormTableHeader } from './FormTable'

interface InputFormTableProps {
  inputs: Record<string, InputType>

  data: Record<string, any>[]

  onChange: (data: Record<string, any>[]) => void

  cols?: number

  error?: string

  permission?: number
}

export const InputFormTable = ({
  inputs = {},
  data = [],
  onChange = () => {},
  cols = 2,
  error,
  permission = 1,
}: InputFormTableProps) => {
  const headers: FormTableHeader[] = []
  Object.keys(inputs).forEach((key) => {
    headers.push({
      key,
      title: inputs[key].title,
    })
  })

  return (
    <div className={`${permission === 3 ? 'bg-gray-100 p-3 border' : ''} rounded-t ${error && 'border-rose-700'}`}>
      <FormTable
        header={headers}
        defaultData={data}
        inputs={inputs}
        cols={cols}
        onChange={onChange}
        permission={permission}
      />
      {error && <p className="peer-invalid:visible text-rose-700 text-[13px] pt-[1px] pl-1">{error}</p>}
    </div>
  )
}
